import React, { Fragment, useEffect, useState } from "react";
import Card from "react-bootstrap/Card";
import { useAuth } from "../context/AuthContext";
import { format } from "date-fns";

export const UserCertHistory = ({ userId, certificationId, refreshKey }) => {
  const { authAxios } = useAuth();
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  const missingKeys =
    userId === null ||
    userId === undefined ||
    certificationId === null ||
    certificationId === undefined;

  useEffect(() => {
    if (missingKeys) {
      setHistory([]);
      return;
    }

    const fetchHistory = async () => {
      setLoading(true);
      try {
        const response = await authAxios().get(
          "/api/backoffice/certs/user_cert_history",
          { params: { user_id: userId, cert_id: certificationId } },
        );
        setHistory(response.data);
      } catch (err) {
        console.log("error fetching cert history:");
        console.log(err);
        setHistory([]);
      } finally {
        setLoading(false);
      }
    };
    fetchHistory();
  }, [userId, certificationId, refreshKey]);

  const formatDate = (value) => {
    if (!value) return "";
    try {
      return format(new Date(value), "dd/MM/yyyy HH:mm");
    } catch (e) {
      return "";
    }
  };

  const body = () => {
    if (missingKeys)
      return (
        <p className="text-muted">
          Select a user and certificate to see its history.
        </p>
      );
    if (loading) return <p className="text-muted">Loading…</p>;
    if (history.length === 0)
      return <p className="text-muted">No history yet.</p>;

    return history.map((row) => (
      <Card key={row.id} className="mb-2">
        <Card.Body>
          <Card.Title className="fs-6 mb-1">
            {row.staffName || "Unknown"}
          </Card.Title>
          <Card.Subtitle className="mb-2 text-muted">
            {formatDate(row.created)}
          </Card.Subtitle>
          <Card.Text style={{ whiteSpace: "pre-wrap" }}>{row.notes}</Card.Text>
        </Card.Body>
      </Card>
    ));
  };

  return (
    <Fragment>
      <h5>History</h5>
      {body()}
    </Fragment>
  );
};
